import { isNumber } from 'fitify-types/src/type-guards/common'
import { useTheme } from 'styled-components'

import { Typography } from '../../../Typography'

import {
  StyledAttribute,
  StyledProgressLevel,
  StyledProgressLevelItem,
  StyledWrapper,
} from './Attribute.Styled'

export type AttributeProgress = 0 | 1 | 2 | 3

type AttributeProps = {
  label: string
  value: string
  progress?: AttributeProgress
}

export const Attribute = ({ label, value, progress }: AttributeProps) => {
  const theme = useTheme()
  return (
    <StyledWrapper>
      <StyledAttribute>
        <Typography
          $color={theme.colors['N Content/Secondary']}
          $variant="Poppins/T3"
        >
          {label}
        </Typography>
        <Typography
          $color={theme.colors['N Content/Primary']}
          $variant="Poppins/T2 - Medium"
        >
          {value}
        </Typography>
      </StyledAttribute>

      {isNumber(progress) && (
        <StyledProgressLevel>
          <StyledProgressLevelItem $isHighlighted={progress > 0} />
          <StyledProgressLevelItem $isHighlighted={progress > 1} />
          <StyledProgressLevelItem $isHighlighted={progress > 2} />
        </StyledProgressLevel>
      )}
    </StyledWrapper>
  )
}
